// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__NQOJA","Search":"Search_Search__GdrXo","searchButton":"Search_searchButton__juggw"};